import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { ReactComponent as ModalCloseIcon } from "../../assets/svg/close-modal.svg";
import { ReactComponent as MinusSign } from "../../assets/svg/minus-sign.svg";
import { ReactComponent as PlusSign } from "../../assets/svg/add-circle.svg";
import { Container, Row, Col } from "react-bootstrap";
import "../visitor/visitor-create/visitor-create.css";
import DOMPurify from 'dompurify';
import { createVehicleTypeApi, getVehicleTypeDetailsApi, updateVehicleTypeApi } from "./setup-api";

const VehicleTypeCreateModal = ({ vehicleTypeId, onSuccess, onCancel }) => {
  const apiUrl = process.env.REACT_APP_API_URL;
  const navigate = useNavigate();
  const [errorMessage, setErrorMessage] = useState("");
  const modalStyle = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      opacity: 1,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 1000,
    },
    modal: {
      backgroundColor: "#ffffff",

      borderRadius: "16px",
      boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
      width: "718px",
      height: "438px",
      overflowY: "auto",
    },
  };


  const [loading, setLoading] = useState(false);
  const [code, setCode] = useState("");
  const [name, setName] = useState("");
  const [dimension, setDimension] = useState("");
  const [length, setLength] = useState("");
  const [breadth, setBreadth] = useState("");
  const [height, setHeight] = useState("");
  const [description, setDescription] = useState("");
  const [duration, setDuration] = useState("");
  useEffect(() => {
    if (vehicleTypeId != null) {
      getVehicleTypeDetails()
    }
  }, []);


  const [validations, setValidations] = useState({
    "code": "",
    "name": "",
    "dimensiontype": "",
    "length": "",
    "width": "",
    "height": "",
    "duration": "",
  });
  const getVehicleTypeDetails = async () => {
    try {
      const response = await getVehicleTypeDetailsApi(vehicleTypeId);
      if (response.status === true) {
        console.log(response)
        var vehicleTypeDetails = response.vehicletypes;
        console.log(vehicleTypeDetails)
        setCode(vehicleTypeDetails.code ?? '')
        setName(vehicleTypeDetails.vehicle_name ?? '')
        setDimension(vehicleTypeDetails.dimensiontype ?? '')
        setLength(vehicleTypeDetails.length ?? '')
        setBreadth(vehicleTypeDetails.width ?? '')
        setHeight(vehicleTypeDetails.height ?? '')
        setDuration(vehicleTypeDetails.duration ?? '')
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };
  const submitVehicleType = async () => {

    const dataBeforeSanitize = {
      "id": vehicleTypeId != null ? vehicleTypeId : "",
      "code": code,
      "name": name,
      "dimensiontype": dimension,
      "length": length,
      "width": breadth,
      "height": height,
      "duration": duration,
    };
    const dataAfterSanitize = {};
    Object.entries(dataBeforeSanitize).forEach(([key, value]) => {
      if (typeof value === "boolean" || typeof value === "number" || Array.isArray(value)) {
        dataAfterSanitize[key] = value;
      } else {
        dataAfterSanitize[key] = DOMPurify.sanitize(value);
      }
    });
    if (vehicleTypeId == null) {
      const response = await createVehicleTypeApi(dataAfterSanitize);
      if (response.status === 200) {
        if (response.data.status === true) {
          onSuccess(response.data)
        }
      }

      if (response.status === 400) {
        new Promise((resolve, reject) => {

          const validationTemp = {
            "code": "",
            "name": "",
            "dimensiontype": "",
            "length": "",
            "width": "",
            "height": "",
            "duration": "",
          };
          Object.entries(response.data.error).forEach(([key, value]) => {
            console.log(`${key}: ${value}`);
            validationTemp[key] = value.length === 0 ? '' : value[0];
          });
          console.log('validationTemp...', validationTemp);
          setValidations(validationTemp);
        });
      }
    } else {
      const response = await updateVehicleTypeApi(dataAfterSanitize, vehicleTypeId);
      if (response.status === 200) {
        if (response.data.status === true) {
          onSuccess(response.data)
        }
      }
      if (response.status === 400) {
        new Promise((resolve, reject) => {

          const validationTemp = {
            "code": "",
            "name": "",
            "dimensiontype": "",
            "length": "",
            "width": "",
            "height": "",
            "duration": "",
          };
          Object.entries(response.data.error).forEach(([key, value]) => {
            console.log(`${key}: ${value}`);
            validationTemp[key] = value.length === 0 ? '' : value[0];
          });
          console.log('validationTemp...', validationTemp);
          setValidations(validationTemp);
        });
      }
    }
  };
  const [lastKey, setLastKey] = useState("");
  const handleChange = (event) => {
    const inputText = event.target.value;
    if (/^\d{0,2}(:\d{0,2})?$/.test(inputText)) {
      console.log(event.key)
      if (lastKey === "Backspace") {
        setDuration(inputText);
      } else {
        setDuration(inputText.length === 2 ? inputText + ':' : inputText);
      }
    }
  };
  return (<div style={modalStyle.overlay}>
    <div style={modalStyle.modal}>
      <div style={{ color: "#ffffff" }}>
        <div className="modal-header style-justify-between"
        >
          <div className="add-item-modal-title"
          >
            {vehicleTypeId != null ? "Edit " : "Add "} vehicle type
          </div>
          <ModalCloseIcon
            style={{ cursor: "pointer" }}
            onClick={onCancel}
          />
        </div>

        <div style={{ padding: "16px 24px", }}>
          <Row style={{ width: '670px' }}>
            <Col xs={12} sm={12} md={6} >
              <div className="field-title">
                Code<span style={{ color: '#FF4444' }}>*</span>
              </div>
              <input
                type="text"
                placeholder="Enter here"
                className="input-field mt-2 w-100"
                value={code}
                onChange={(event) => {
                  setCode(event.target.value); // Update state with input value
                }}
              />
              <span className="field-error" >{validations.code}</span>
            </Col>
            <Col xs={12} sm={12} md={6}>
              <div className="field-title">
                Name<span style={{ color: '#FF4444' }}>*</span>
              </div>
              <input
                type="text"
                placeholder="Enter here"
                className="input-field mt-2 w-100"
                value={name}
                onChange={(event) => {
                  setName(event.target.value); // Update state with input value
                }}
              />
              <span className="field-error" >{validations.name}</span>
            </Col>
            <Col sm={6}>
              <div
                style={{
                  paddingTop: "6px",
                  paddingBottom: "6px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "start",
                  fontSize: "13px",
                  fontWeight: "500",
                  color: "#212129",
                }}
              >
                Duration
              </div>
              <input
                type="text"
                className="form-control"
                value={duration}
                onChange={handleChange}
                onKeyDown={(event) => { setLastKey(event.key); }}
                placeholder="HH:MM"
              />
              <span style={{ fontSize: "12px", fontWeight: 400, color: "#FF4444", }}>{validations.duration}</span>
            </Col>
          </Row>
          <div className="style-justify-between mt-3">
            <div className="field-title">
              Dimension
            </div>
            <select className="select3 w-400 input-field" id="dimensiontype" value={dimension} onChange={(event) => { setDimension(event.target.value); }} style={{ cursor: 'pointer', fontSize: '14px', fontWeight: '500', lineHeight: '18.9px', color: '#8790A1', height: '40px', borderRadius: '10px', border: '0.7px solid #E5E5E5', padding: '0 8px', gap: '77px', backgroundColor: '#FFFFFF' }}>
              <option value="meter">Meter</option>
              <option value="cm">CM</option>
              <option value="kg">KG</option>
            </select>
          </div>
          <Row className="mt-2" style={{ width: '670px' }}>
            <Col xs={12} sm={12} md={4} >
              <div className="field-title">
                Length
              </div>
              <input
                type="text"
                placeholder="Enter here"
                className="input-field mt-2 w-100"
                value={length}
                onChange={(event) => {
                  const value = event.target.value.replace(
                    /\D/g,
                    ""
                  );
                  setLength(value); // Update state with input value
                }}
              />
              <span className="field-error" >{validations.length}</span>
            </Col>
            <Col xs={12} sm={12} md={4}>
              <div className="field-title">
                Breadth
              </div>
              <input
                type="text"
                placeholder="Enter here"
                className="input-field mt-2 w-100"
                value={breadth}
                onChange={(event) => {
                  const value = event.target.value.replace(
                    /\D/g,
                    ""
                  );
                  setBreadth(value);  // Update state with input value
                }}
              />
              <span className="field-error" >{validations.width}</span>
            </Col>
            <Col xs={12} sm={12} md={4}>
              <div className="field-title">
                Height
              </div>
              <input
                type="text"
                placeholder="Enter here"
                className="input-field mt-2 w-100"
                value={height}
                onChange={(event) => {
                  const value = event.target.value.replace(
                    /\D/g,
                    ""
                  );
                  setHeight(value);  // Update state with input value
                }}
              />
              <span className="field-error" >{validations.width}</span>
            </Col>
          </Row>






          <Row className="mt-3" style={{ width: '670px' }}
          >
            <div className="style-justify-end">
              <div
                onClick={onCancel} className="cancel-modal-btn style-justify-center"
              >
                Cancel
              </div>
              <div className="save-modal-btn style-justify-center"
                onClick={(e) => {
                  submitVehicleType()

                }}>
                {vehicleTypeId != null ? "Update " : "Save "}
              </div>
            </div>
          </Row>
        </div>
      </div>
    </div>
  </div>);

}

export default VehicleTypeCreateModal;